import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import CustomTable from '../../../components/CustomTable';
import auth from '../../../common/utility/auth';

export default function ResultList(props) {
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">

                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="eye"
                                    size={"small"}
                                    loading={props.loadingVer}
                                    onClick={() => props.onView(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={"Anular"}>
                                <Button
                                    disabled={row.idEstado == 3 ? false : true}
                                    type={"danger"}
                                    icon={"close"}
                                    size={"small"}
                                    onClick={() => props.onAnular(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={"Solicitud"}>
                                <Button
                                    disabled={row.idEstado == 3 ? false : true}
                                    type="primary"
                                    icon="plus"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onSolicitud(row)}
                                />
                            </Tooltip>


                            <Tooltip placement="top" title={"Editar"}>
                                <Button
                                    disabled={row.hasSolicitud ? true : row.idEstado == 3 ? false : true}
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title={"Arqueo Caja"}>
                                <Button
                                    disabled={row.idEstado == 3 ? false : true}
                                    type="success"
                                    icon="check-square"
                                    size={"small"}
                                    onClick={() => props.onArqueo(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title={"Cerrar Caja"}>
                                <Button
                                    type="success"
                                    icon="issues-close"
                                    size={"small"}
                                    disabled={row.idEstado == 5 ? false : true}
                                    onClick={() => props.onCierre(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title={"Imprimir"}>
                                <Button
                                    type="primary"
                                    icon="printer"
                                    size={"small"}
                                    onClick={() => props.onImprimir(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Fecha Apertura',
                    dataIndex: 'fecha',
                    key: 'fecha',
                    sorter: true,
                    render: (value, row) => (
                        <span>{value} {row.hora}</span>
                    )
                },

                {
                    title: 'Fecha Cierre',
                    dataIndex: 'fechaCierre',
                    key: 'fechaCierre',
                    sorter: true,
                    render: (value, row) => (
                        <span>{value} {row.horaCierre}</span>
                    )
                },
                {
                    title: 'Serie - Documento',
                    dataIndex: 'serieCorrelativo',
                    key: 'serieCorrelativo',
                    sorter: true
                },
                {
                    title: 'Establecimiento',
                    dataIndex: 'establecimiento',
                    key: 'establecimiento',
                    sorter: true
                },
                {
                    title: 'Caja',
                    dataIndex: 'caja',
                    key: 'caja',
                    sorter: true
                },
                {
                    title: 'Moneda',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },
                {
                    title: 'Monto Apertura',
                    dataIndex: 'montoApertura',
                    key: 'montoApertura',
                    align: 'right',
                    render: (value) => (
                        <span>{value.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Sobrante o Faltante',
                    dataIndex: 'monto',
                    key: 'monto',
                    align: 'right',

                },
                {
                    title: 'Referecia Re-Ajuste',
                    dataIndex: 'referencia',
                    key: 'referencia',
                    sorter: true
                },
                {
                    title: 'Tipo Cambio',
                    dataIndex: 'tipoCambio',
                    key: 'tipoCambio',
                    sorter: true,
                    render: (value) => (
                        <span>{value.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Responsable Caja',
                    dataIndex: 'empleadoCaja',
                    key: 'empleadoCaja',
                    sorter: true
                },

                {
                    title: 'Responsable Arqueo',
                    dataIndex: 'empleadoArqueo',
                    key: 'empleadoArqueo',
                    sorter: true
                },

                {
                    title: 'Estado',
                    dataIndex: 'idEstado',
                    key: 'idEstado',
                    align: 'center',
                    width: "90px",
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            {(() => {
                                switch (value) {
                                    case 1: //registado
                                        return <Tag color={"green"}>{row.estado}</Tag>;
                                    case 2://ANULADA
                                        return <Tag color={"red"}>{row.estado}</Tag>;
                                    case 3://APERTURADA
                                        return <Tag color={"green"}>{row.estado}</Tag>;
                                    case 4://CERRADO
                                        return <Tag color={"red"}>{row.estado}</Tag>;
                                    case 5://POR CERRAR
                                        return <Tag color={"blue"}>{row.estado}</Tag>;
                                    default:
                                        return null;
                                }
                            })()}

                        </div>)
                    }
                }
            ]}
        />
    );
}